import { useState } from 'react';
import { Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useActions } from 'utils/hooks';
import { selectAccountName } from 'store/account/selectors';
import paths from 'routing/routes/_paths';
import * as authActions from 'store/auth/actions';

const User = () => {
  const name = useSelector(selectAccountName);

  const [isOpen, setIsOpen] = useState(false);
  const [logout] = useActions([authActions.logout]);

  const getUserInitials = () => {
    if (name) {
      const words = name.split(' ');

      return `${words[0].charAt(0)}${words[1] ? `${words[1].charAt(0)}` : ''}`;
    } else {
      return '';
    }
  };

  return (
    <Dropdown
      className="sidebar-navbar--user"
      direction="right"
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
    >
      <DropdownToggle color="link" className="p-0 text-center">
        {getUserInitials()}
      </DropdownToggle>
      <DropdownMenu className="ms-2" right={true}>
        <div className="fs-12 fw-medium account-name text-truncate">{name || ''}</div>
        <Link className="d-inline-block dropdown-item" to={paths.profile}>
          Profile
        </Link>
        <DropdownItem className="d-inline-block pointer" onClick={logout}>
          Logout
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
export default User;
